<h1 mat-dialog-title>Delete</h1>
<p>
  Are you sure you want to delete {{ this.data.type }}: {{ this.data.url }}?
</p>
<div mat-dialog-actions>
  <button id="delete" mat-button (click)="delete()">Delete</button>
  <button id="cancel" mat-button (click)="cancel()">Cancel</button>
</div>
